import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';

import { httpClient, rikHttpClient } from 'services/httpClient';
import interceptors from 'services/httpClient/interceptors';

import rootReducers from './rootReducers';
import rootSagas from './rootSagas';

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key:
    process.env.NODE_ENV === 'development'
      ? 'pro_rik_app_dev'
      : 'afecb6ad2083069a3c688ccb43b26c4e',
  storage,
  whitelist: ['auth'],
  timeout: 1,
};

export const reducers = combineReducers(rootReducers);

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ thunk: false, serializableCheck: false }).concat(
      sagaMiddleware,
    ),
});

sagaMiddleware.run(rootSagas);
interceptors.setToken(httpClient, store);
interceptors.setToken(rikHttpClient, store);
interceptors.logout(httpClient, store);
interceptors.logout(rikHttpClient, store);
